module.exports = __webpack_public_path__ + "img/mobile/BetBar/btn-betland-up@2x.png?1.0.17";